export const DATE_RANGE_FIELD_LABEL = 'Date range';
export const DEFAULT_ORDER_NUM = 9999;
